import amplitude from "amplitude-js";
import environment from "./environment";

// docs: https://developers.amplitude.com/

let disableAnalytics = environment.name === "localhost" ||  environment.name === "devtest";

export const initAnalytics = appVersion => {
  if (disableAnalytics) return;

  amplitude.getInstance().init(environment.aplitudeAPIkey);

  if (appVersion) amplitude.getInstance().setVersionName(appVersion);
};

export const logOutUserAnalytics = () => {
  if (disableAnalytics) return;

  amplitude.getInstance().setUserId(null);
};

export const logInUserAnalytics = (email, name, userId, appVersion) => {
  if (disableAnalytics) return; // disable analytics on localhost

  var userProperties = {
    email,
    nombre: name,
    userId,
    appVersion
  };

  amplitude.getInstance().setUserProperties(userProperties);
};

export const logEventAnalytics = (eventName, eventData) => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().logEvent(eventName, eventData);
};
